import {
   Accordion,
   AccordionDetails,
   AccordionSummary, Autocomplete,
   Button, Checkbox,
   FormControl,
   FormControlLabel,
   FormGroup, FormLabel, InputLabel, MenuItem, Modal, Radio, RadioGroup, Select,
   Stack, TextField
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {PhotoCamera} from "@mui/icons-material";
import Box from "@mui/material/Box";
import AssistantDirectionIcon from "@mui/icons-material/AssistantDirection";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import * as React from "react";
import {useContext, useEffect} from "react";
import ECContext from "../../context/inspections/ECContext";
import { Image } from 'mui-image'
import test_image from '../layout/assets/test_image.jpg'
import UploadAndDisplayImage from "../tools/upload_image";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {
   Magnifier,
   GlassMagnifier,
   SideBySideMagnifier,
   PictureInPictureMagnifier,
   MOUSE_ACTIVATION,
   TOUCH_ACTIVATION
} from "react-image-magnifiers";
import {
   createNewDeal,
   getB24accessToken, getDealList, getUsersList, getImageUrl, moveDealToClaimFiledStage,
   saveGeneralBlock,
   savePhotoIntoFolder,
   updateInspection,
   isDealWasCreated,
} from "../../context/inspections/ECActions";
import { SnackbarProvider, useSnackbar } from 'notistack';
import GalleryIcon from '@mui/icons-material/CollectionsOutlined';

import CustomCamera from '../tools/custom_camera'
import 'react-html5-camera-photo/build/css/index.css';
import spinner from '../layout/assets/loading.gif'
import LoadingButton from "@mui/lab/LoadingButton";


export default function General() {

   //const [photoOfFrontOfProperty, setPhotoOfFrontOfProperty] = React.useState(test_image);
   const [photoOfFrontOfProperty, setPhotoOfFrontOfProperty] = React.useState('');
   const [name, setName] = React.useState('');
   const [lastName, setLastName] = React.useState('');
   const [address, setAddress] = React.useState('');
   const [phone, setPhone] = React.useState('');
   const [email, setEmail] = React.useState('');
   const [scopeOfWork, setScopeOfWork] = React.useState({roof: false, siding: false, gutters: false, windows: false, metals: false, interior: false});
   const [inspectorName, setInspectorName] = React.useState('');
   const [inspectorId, setInspectorId] = React.useState('');
   const [isThePropertyOwnerPresent, setIsThePropertyOwnerPresent] = React.useState('');
   const [weatherCondition, setWeatherCondition] = React.useState('');
   const [approximateAgeOfStructure, setApproximateAgeOfStructure] = React.useState('');
   const [approximateAgeOfSiding, setApproximateAgeOfSiding] = React.useState('');
   const [approximateAgeOfGutters, setApproximateAgeOfGutters] = React.useState('');
   const [approximateAgeOfRoof, setApproximateAgeOfRoof] = React.useState('');
   const [additionalInformation, setAdditionalInformation] = React.useState('');
   const [insurerCarrier, setInsurerCarrier] = React.useState({label: ''});
   const [inputInsurerCarrier, setInputInsurerCarrier] = React.useState('');
   const [policyNumber, setPolicyNumber] = React.useState('');
   const [claimNumber, setClaimNumber] = React.useState('');
   const [damageCausedBy, setDamageCausedBy] = React.useState({hail: false, wind: false, hurricane: false, tornado: false, fire: false, flooding: false});
   const [dateOfLoss, setDateOfLoss] = React.useState(null);
   const [creationDate, setCreationDate] = React.useState(null);
   const [inspectionResult, setInspectionResult] = React.useState('');

   const [linkedDealId, setLinkedDealId] = React.useState('');
   const [dealList, setDealList] = React.useState([]);

   const [secondResponsiblePersonId, setSecondResponsiblePersonId] = React.useState('');
   const [userList, setUserList] = React.useState([]);


   const [testImage, setTestImage] = React.useState(test_image);
   //const [testImage, setTestImage] = React.useState('');

   const { enqueueSnackbar } = useSnackbar();
   const [tempBase64, setTempBase64] = React.useState('')

   const [movingToClaimFiledStage, setMovingToClaimFiledStage] = React.useState(false)

   const { flagReloadDataforNamesAndAddress, flagReloadDataforLinkedDeal, getNoPhotoDataRequest, newIspectionAllData, flagReloadDatafromInspectionAllData, flagCleanAllControlsData, inspectionGeneralBlockInfo, flagNeedToUpdatePhotosForGeneralBlock, inspectionAllData, dispatch, showCamera, saveRequest, editInspectionId, inspections, access_token_data } = useContext(ECContext)


   useEffect(() => {
      const wrap = async () => {

         const tmpDealList = await getDealList(access_token_data, inspectionAllData)
         const reformattedDealList = tmpDealList.map(({ ID, TITLE, CATEGORY_ID }) => ({ id: ID, label: `(${ID}:${CATEGORY_ID}) ${TITLE}` }));
         setDealList(reformattedDealList)

         const tmpUserList = await getUsersList(access_token_data, inspectionAllData)
         const reformattedUserList = tmpUserList.map(({ ID, NAME, LAST_NAME }) => ({ id: ID, label: `[${ID}] ${NAME} ${LAST_NAME}` }));
         setUserList(reformattedUserList)

      }
      wrap().then(r => {});
   }, []);

   useEffect(() => {

      if(inspectionGeneralBlockInfo.showBlock) {
         console.log(`We're inside general compnent and inspectionId here is: ${editInspectionId}`)
      }
      setShow(inspectionGeneralBlockInfo.showBlock)
   }, [inspectionGeneralBlockInfo]);

   useEffect(() => {

      if(/*inspectionGeneralBlockInfo.showBlock*/ /*&& saveRequest === true*/ saveRequest === true) {
         //dispatch({ type: 'DROP_SAVE_REQUEST' })

         //console.log('access_token_data.inspectorName: '+access_token_data.inspectorName)

         let generalBlockData = {

            PROPERTY_789: linkedDealId,      //_Linked Deal
            PROPERTY_1313: secondResponsiblePersonId,

            PROPERTY_799:  name,             //general.Name
            PROPERTY_1103: {
               'n0': (inspectionAllData.hasOwnProperty('photoOfFrontOfProperty') ? inspectionAllData.photoOfFrontOfProperty.FILE_ID : '')
            },                               //general.Photo of Front of Property
            PROPERTY_801:  lastName,         //general.Last name
            PROPERTY_803:  address,          //general.Address
            PROPERTY_805:  phone,            //general.Phone
            PROPERTY_1109: email,            //general.Email
            PROPERTY_807:  inspectorName.length == 0 ? access_token_data.inspectorName : inspectorName,    //general.Inspector Name // InspectorName только при создании фиксируем пока
            PROPERTY_1111:  inspectorId.length == 0 ? access_token_data.user_id : inspectorId,    //general.Inspector Id
            PROPERTY_809:  ( () => { //general.Is the Property Owner Present
               switch (isThePropertyOwnerPresent) {
                  case 'male':
                     return 195
                  case 'female':
                     return 193
                  default:
                     return ''
               }
            } )(),
            PROPERTY_811:  weatherCondition,          //general.Weather conditions
            PROPERTY_813:  approximateAgeOfStructure, //general.Approximate Age of Structure
            PROPERTY_815:  approximateAgeOfSiding,    //general.Approximate Age of Siding
            PROPERTY_817:  approximateAgeOfGutters,   //general.Approximate Age of Gutters
            PROPERTY_819:  approximateAgeOfRoof,      //general.Approximate Age of Roof
            PROPERTY_821:  additionalInformation,     //general.Additional Information
            PROPERTY_823:  insurerCarrier,            //general.Insurer Carrier
            PROPERTY_825:  policyNumber,              //general.Policy Number
            PROPERTY_827:  claimNumber,               //general.Claim Number
            PROPERTY_829:  ( () => {                  //general.Damage Caused By
               let damages = []
               if(damageCausedBy.flooding) damages.push(215)
               if(damageCausedBy.hail) damages.push(205)
               if(damageCausedBy.wind) damages.push(207)
               if(damageCausedBy.fire) damages.push(213)
               if(damageCausedBy.tornado) damages.push(211)
               if(damageCausedBy.hurricane) damages.push(209)

               return damages;
            } )(),

            PROPERTY_831:  dateOfLoss,                //general.Date of Loss
            PROPERTY_833:  inspectionResult,          //general.Inspection Result
            PROPERTY_1101: ( () => {                  //general.Scope of Work
               let scopes = []
               if(scopeOfWork.roof) scopes.push(281)
               if(scopeOfWork.interior) scopes.push(287)
               if(scopeOfWork.gutters) scopes.push(285)
               if(scopeOfWork.windows) scopes.push(351)
               if(scopeOfWork.metals) scopes.push(353)
               if(scopeOfWork.siding) scopes.push(283)

               return scopes;
            } )(),
            PROPERTY_1311: (!inspectionAllData.isNew ? creationDate : (new Date()).toLocaleDateString("en-US") ),

            NO_PHOTOS_DATA: {
               "Name":  name,             //general.Name
               "Last Name":  lastName,         //general.Last name
               "Address":  address,          //general.Address
               "Phone":  phone,            //general.Phone
               "Email": email,            //general.Email
               "Owner":  isThePropertyOwnerPresent,
               "Weather Conditions":  weatherCondition,          //general.Weather conditions
               "Approximate Age of Structure":  approximateAgeOfStructure, //general.Approximate Age of Structure
               "Approximate Age of Siding":  approximateAgeOfSiding,    //general.Approximate Age of Siding
               "Approximate Age of Gutters":  approximateAgeOfGutters,   //general.Approximate Age of Gutters
               "Approximate Age of Roof":  approximateAgeOfRoof,      //general.Approximate Age of Roof
               "Additional Information":  additionalInformation,     //general.Additional Information
               "Insurer Carrier":  insurerCarrier,            //general.Insurer Carrier
               "Policy Number":  policyNumber,              //general.Policy Number
               "Claim Number":  claimNumber,               //general.Claim Number
               "Damage Caused By":  ( () => {                  //general.Damage Caused By
                  let damages = []
                  if(damageCausedBy.flooding) damages.push('Flooding')
                  if(damageCausedBy.hail) damages.push('Hail')
                  if(damageCausedBy.wind) damages.push('Wind')
                  if(damageCausedBy.fire) damages.push('Fire')
                  if(damageCausedBy.tornado) damages.push('Tornado')
                  if(damageCausedBy.hurricane) damages.push('Hurricane')

                  return damages.toString();
               } )(),

               "Date of Loss":  dateOfLoss,                //general.Date of Loss
               "Inspection Result":  inspectionResult,          //general.Inspection Result
               "Scope of Work": ( () => {                  //general.Scope of Work
                  let scopes = []
                  if(scopeOfWork.roof) scopes.push('Roof')
                  if(scopeOfWork.interior) scopes.push('Interior')
                  if(scopeOfWork.gutters) scopes.push('Gutters')
                  if(scopeOfWork.siding) scopes.push('Siding')
                  if(scopeOfWork.windows) scopes.push('Windows')
                  if(scopeOfWork.metals) scopes.push('Metals')

                  return scopes.toString();
               } )()
            }




         }

         if(inspectionAllData.isAdditonalStructureInspection != true) //Имя меняем только для основного строения
            generalBlockData = {...generalBlockData, NAME: `${name} ${lastName} ${address}`,}


         dispatch({ type: 'UPDATE_INSPECTION_ALL_DATA_WITH_GENERAL_BLOCK', payload: generalBlockData } )

         // triggering Save in InspectionEdit component
         dispatch({ type: 'SET_GENERAL_READY_TO_SAVE_FLAG' })

// console.log('=== inspectionAllData in general save_request block ==')
// console.log(inspectionAllData)



/*         const getBase64 = async () => {
            const base64 = await toBase64(photoOfFrontOfProperty[0])


            const params = {
               NAME: address,
               GENERAL_PHOTO_OF_FRONT_OF_PROPERTY: {"fileData": ["1.gif", "R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="]}
               //GENERAL_PHOTO_OF_FRONT_OF_PROPERTY: [photoOfFrontOfProperty[0].name, 'data:image/jpeg;base64,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']
               //GENERAL_PHOTO_OF_FRONT_OF_PROPERTY: [photoOfFrontOfProperty[0].name, encodeURIComponent(base64)]
               //GENERAL_PHOTO_OF_FRONT_OF_PROPERTY: base64

            }


            console.log("params:")
            console.log(params)

            //console.log(`running useEffect with saveRequest. access_token_data: ${access_token_data}, params: ${params}`)

            saveGeneralBlock(access_token_data, params)

            enqueueSnackbar('Saved!', 'success');
         }
         getBase64()*/


      }
   }, [saveRequest]);

   useEffect(() => {


      if(flagNeedToUpdatePhotosForGeneralBlock == true) {
         dispatch({ type: 'DROP_UPDATE_PHOTO_FOR_GENERAL' })

         console.log("inspectionAllData:")
         console.log(inspectionAllData)

         if(inspectionAllData.hasOwnProperty('photoOfFrontOfProperty' )) {
            if(inspectionAllData.photoOfFrontOfProperty.hasOwnProperty("DETAIL_URL"))
               if(inspectionAllData.photoOfFrontOfProperty.DETAIL_URL != 0)
                  setPhotoOfFrontOfProperty(inspectionAllData.photoOfFrontOfProperty.DETAIL_URL)
         }
      }

   }, [flagNeedToUpdatePhotosForGeneralBlock]);

   useEffect(() => {
      //setPhotoOfFrontOfProperty(test_image);

      setPhotoOfFrontOfProperty([])

      delete inspectionAllData.photoOfFrontOfProperty

      setName('');
      setLastName('');
      setAddress('');
      setPhone('');
      setEmail('')

      setScopeOfWork({roof: false, siding: false, gutters: false, windows: false, metals: false, interior: false});
      setInspectorName('');
      setInspectorId('');
      setIsThePropertyOwnerPresent('');
      setWeatherCondition('');
      setApproximateAgeOfStructure('');
      setApproximateAgeOfSiding('');
      setApproximateAgeOfGutters('');
      setApproximateAgeOfRoof('');
      setAdditionalInformation('');
      setInsurerCarrier({label: ''});
      setInputInsurerCarrier('');
      setPolicyNumber('');
      setClaimNumber('');
      setDamageCausedBy({hail: false, wind: false, hurricane: false, tornado: false, fire: false, flooding: false});
      setDateOfLoss(null);
      setInspectionResult('');
      setLinkedDealId('');
      setCreationDate('')
      setSecondResponsiblePersonId('')
      setUserList([])
   }, [flagCleanAllControlsData]);

   useEffect(() => {

      if(!inspectionAllData.hasOwnProperty('PROPERTY_799' )) return;

console.log('RELOADING data... in general.jsx')
console.log('current inspectionAllData:')
console.log(inspectionAllData)

      // taking Photo data


      const photoOfFrontOfProperty = async () => {
         if(inspectionAllData.hasOwnProperty('photoOfFrontOfProperty' )) {
            const imageUrl = await getImageUrl(access_token_data, inspectionAllData.photoOfFrontOfProperty.ID)
            setPhotoOfFrontOfProperty(imageUrl.DOWNLOAD_URL)
         }
      }
      photoOfFrontOfProperty()


      setLinkedDealId(inspectionAllData.PROPERTY_789)                         //_Linked Deal
      setName(inspectionAllData.PROPERTY_799)                                 //general.Name
      setLastName(inspectionAllData.PROPERTY_801)                             //general.Last name
      setAddress(inspectionAllData.PROPERTY_803)                              //general.Address
      setPhone(inspectionAllData.PROPERTY_805)                                //general.Phone
      setEmail(inspectionAllData.PROPERTY_1109)                                //general.Email
      setInspectorName(inspectionAllData.PROPERTY_807)                        //general.Inspector Name
      setInspectorId( inspectionAllData.hasOwnProperty('PROPERTY_1111') ? inspectionAllData.PROPERTY_1111 : access_token_data.user_id )                        //general.InspectorId
      //setInspectorId(inspectionAllData.PROPERTY_1111)                        //general.InspectorId
      //setInspectorName(inspectionAllData.PROPERTY_807)                        //general.Inspector Name
      setIsThePropertyOwnerPresent(( () => {                                  //general.Is the Property Owner Present
         switch (inspectionAllData.PROPERTY_809) {
            case 195:
               return 'male'
            case 193:
               return 'female'
            default:
               return ''
         }
      } )())
      setWeatherCondition(inspectionAllData.PROPERTY_811) //general.Weather conditions
      setApproximateAgeOfStructure(inspectionAllData.PROPERTY_813)//general.Approximate Age of Structure
      setApproximateAgeOfSiding(inspectionAllData.PROPERTY_815)//general.Approximate Age of Siding
      setApproximateAgeOfGutters(inspectionAllData.PROPERTY_817)//general.Approximate Age of Gutters
      setApproximateAgeOfRoof(inspectionAllData.PROPERTY_819)//general.Approximate Age of Roof
      setAdditionalInformation(inspectionAllData.PROPERTY_821)//general.Additional Information
      setInsurerCarrier(inspectionAllData.PROPERTY_823)//general.Insurer Carrier
      setPolicyNumber(inspectionAllData.PROPERTY_825)//general.Policy Number
      setClaimNumber(inspectionAllData.PROPERTY_827)//general.Claim Number
      setDateOfLoss(inspectionAllData.PROPERTY_831)//general.Date of Loss
      setInspectionResult(inspectionAllData.PROPERTY_833)//general.Inspection Result

      let tempDamagedCausedBy = damageCausedBy
      if(inspectionAllData.PROPERTY_829.indexOf(215) != -1) tempDamagedCausedBy = {...tempDamagedCausedBy, flooding: true}
      if(inspectionAllData.PROPERTY_829.indexOf(205) != -1) tempDamagedCausedBy = {...tempDamagedCausedBy, hail: true}
      if(inspectionAllData.PROPERTY_829.indexOf(207) != -1) tempDamagedCausedBy = {...tempDamagedCausedBy, wind: true}
      if(inspectionAllData.PROPERTY_829.indexOf(213) != -1) tempDamagedCausedBy = {...tempDamagedCausedBy, fire: true}
      if(inspectionAllData.PROPERTY_829.indexOf(211) != -1) tempDamagedCausedBy = {...tempDamagedCausedBy, tornado: true}
      if(inspectionAllData.PROPERTY_829.indexOf(209) != -1) tempDamagedCausedBy = {...tempDamagedCausedBy, hurricane: true}
      setDamageCausedBy(tempDamagedCausedBy)

      let tempScopeOfWork = scopeOfWork
      if(inspectionAllData.PROPERTY_1101.indexOf(281) != -1) tempScopeOfWork = {...tempScopeOfWork, roof: true}
      if(inspectionAllData.PROPERTY_1101.indexOf(287) != -1) tempScopeOfWork = {...tempScopeOfWork, interior: true}
      if(inspectionAllData.PROPERTY_1101.indexOf(285) != -1) tempScopeOfWork = {...tempScopeOfWork, gutters: true}
      if(inspectionAllData.PROPERTY_1101.indexOf(283) != -1) tempScopeOfWork = {...tempScopeOfWork, siding: true}
      if(inspectionAllData.PROPERTY_1101.indexOf(351) != -1) tempScopeOfWork = {...tempScopeOfWork, windows: true}
      if(inspectionAllData.PROPERTY_1101.indexOf(353) != -1) tempScopeOfWork = {...tempScopeOfWork, metals: true}
      setScopeOfWork(tempScopeOfWork)

      setCreationDate(inspectionAllData.PROPERTY_1311)
      setSecondResponsiblePersonId(inspectionAllData.PROPERTY_1313)


      // set(inspectionAllData.)
      // set(inspectionAllData.)
      // set(inspectionAllData.)


      //    PROPERTY_829:  ( () => {                  //general.Damage Caused By
      //    let damages = []
      //    if(damageCausedBy.flooding) damages.push(215)
      //    if(damageCausedBy.hail) damages.push(205)
      //    if(damageCausedBy.wind) damages.push(207)
      //    if(damageCausedBy.fire) damages.push(213)
      //    if(damageCausedBy.tornado) damages.push(211)
      //    if(damageCausedBy.hurricane) damages.push(209)
      //
      //    return damages;
      // } )(),
      //
      //    PROPERTY_1101: ( () => {                  //general.Scope of Work
      //    let scopes = []
      //    if(scopeOfWork.roof) scopes.push(281)
      //    if(scopeOfWork.interior) scopes.push(287)
      //    if(scopeOfWork.gutters) scopes.push(285)
      //    if(scopeOfWork.siding) scopes.push(283)
      //
      //    return scopes;
      // } )(),




   }, [flagReloadDatafromInspectionAllData]);

   useEffect(() => {

      if(!inspectionAllData.hasOwnProperty('PROPERTY_799' )) return;

      console.log('RELOADING data... in general.jsx FOR LinkedDeal field')
      console.log('current inspectionAllData:')
      console.log(inspectionAllData)

      setLinkedDealId(inspectionAllData.PROPERTY_789)                         //_Linked Deal

   }, [flagReloadDataforLinkedDeal]);

   useEffect(() => {

      console.log('RELOADING data... in general.jsx FOR Names and Address fields')

      if(inspectionAllData.PROPERTY_799 != undefined)
         setName(inspectionAllData.PROPERTY_799)                                 //general.Name

      if(inspectionAllData.PROPERTY_801 != undefined)
         setLastName(inspectionAllData.PROPERTY_801)                             //general.Last name

      if(inspectionAllData.PROPERTY_1109 != undefined)
         setEmail(inspectionAllData.PROPERTY_1109)                             //general.Email

      if(inspectionAllData.PROPERTY_805 != undefined)
         setPhone(inspectionAllData.PROPERTY_805)                             //general.Phone


      if(inspectionAllData.PROPERTY_803 != undefined)
         setAddress(inspectionAllData.PROPERTY_803)                              //general.Address




   }, [flagReloadDataforNamesAndAddress]);




   const [show, setShow] = React.useState(false);
   const [expanded, setExpanded] = React.useState('panel_inspection');
   const [expanded2, setExpanded2] = React.useState('');
   const reduce = require('image-blob-reduce')();

   const insuranceCarriers = [
      { label: 'Minnesota Insurance Group Inc', id: 2},
      { label: 'Pinnacle Insurance Agency of Minnesota, LLC', id:	4},
      { label: 'AAA Catastrophe Office', id:	7},
      { label: 'Acuity', id:	9},
      { label: 'AIG', id:	11},
      { label: 'Allied Insurance', id:	13},
      { label: 'Allstate', id:	15},
      { label: 'Ameriprise', id:	17},
      { label: 'American Family', id:	19},
      { label: 'American National General Insurance', id: 21},
      { label: 'AMEX Assurance', id:	23},
      { label: 'Amica', id:	25},
      { label: 'Amica Mutual (MN only)', id:	27},
      { label: 'Austin Mutual', id:	29},
      { label: 'Auto Club Ins', id:	31},
      { label: 'Auto Owners', id:	33},
      { label: 'Chubb', id: 35},
      { label: 'Country Financial', id:	37},
      { label: 'Cunningham Lindsey', id:	39},
      { label: 'Damiler Chrysler/Intrepid', id:	41},
      { label: 'Employers Mutual Casualty', id:	43},
      { label: 'Encompass', id:	45},
      { label: 'Farm Bureau Mutual', id:	47},
      { label: 'Farmers Ins Group', id:	49},
      { label: 'Firemans Fund', id:	51},
      { label: 'Foremost Insurance co', id:	53},
      { label: 'GMRC', id:	55},
      { label: 'Grinnell Mutual Reinsurance', id:	57},
      { label: 'Harleysville', id:	59},
      { label: 'Hartford', id:	61},
      { label: 'Homesite Progressive Home Advantage', id:	63},
      { label: 'Horace Mann', id:	65},
      { label: 'Integrity', id:	67},
      { label: 'Kemper A Unitrin Business', id:	69},
      { label: 'Liberty Mutual', id:	71},
      { label: 'Metlife', id:	73},
      { label: 'Midwest Family Mutual', id:	75},
      { label: 'National Farmers Union', id:	77},
      { label: 'National Property/Casualty Company', id:	79},
      { label: 'Nationwide / Allied / Titan / Victoria', id:	81},
      { label: 'Northstar Mutual', id:	83},
      { label: 'Old United Casualty', id:	85},
      { label: 'ProCentury', id:	87},
      { label: 'Progressive', id:	89},
      { label: 'Ram Mutal', id:	91},
      { label: 'Safeco', id:	93},
      { label: 'SECURA', id:	95},
      { label: 'Sentry Claim Services', id:	97},
      { label: 'St Paul/Travelers', id:	99},
      { label: 'Meadowbrook Insurance Group', id:	101},
      { label: 'State Auto Insurance CO', id:	103},
      { label: 'State Farm', id:	105},
      { label: 'Travelers', id:	107},
      { label: 'Triad Guaranty', id:	109},
      { label: 'Unitrin Direct', id:	111},
      { label: 'USAA', id:	113},
      { label: 'West Bend Mutual', id:	115},
      { label: 'Western National Ins Co', id:	117},
      { label: 'West Field', id:	119},
      { label: 'XL Reinsurance America', id:	121},
      { label: 'ZC Sterling Corporation', id:	123},
      { label: 'ESTATE CLAIM SERVICES LLC', id:	127},
      { label: 'lenar', id:	129},
      { label: 'Midwest Claim Services', id:	131},
      { label: 'Universal Property', id:	137},
      { label: 'American Strategic', id:	141},
      { label: 'QBE Insurance', id:	145},
      { label: 'Wisconsin Mutual', id:	147},
      { label: 'Connect (by American Family)', id:	151},
      { label: 'Hippo', id:	153},
      { label: 'Amco Insurance', id:	155},
      { label: 'Badger Insurance', id:	157},
   ];

   const toBase64 = file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
   });

   const handleChange = (panel) => (event, newExpanded) => {
      setExpanded(newExpanded ? panel : false);
   };
   const handleChange2 = (panel) => (event, newExpanded) => {
      setExpanded2(newExpanded ? panel : false);
   };

   const moveDealToClaimFiled = async () => {

      if(!inspectionAllData.hasOwnProperty('PROPERTY_789')) {
         enqueueSnackbar('You need to save the Inpsection first, before ClaimFile the Deal.', 'information');
         return;
      }

      setMovingToClaimFiledStage(true)
      const res = await moveDealToClaimFiledStage(access_token_data, inspectionAllData.PROPERTY_789.id)

      setMovingToClaimFiledStage(false)
      enqueueSnackbar('Success!', 'information');
   }







   return (

   <>
      <Box sx={{mx: 'auto', mt: 2, width: '100%', display: show === true? 'flex' : 'none', flexDirection: 'column'}}>

      <Accordion expanded={expanded === 'panel_inspection'} onChange={handleChange('panel_inspection')}>
         <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="inspection-content"
            id="inspection-header"
         >
            <Typography>Inspection</Typography>
         </AccordionSummary>
         <AccordionDetails>

{/*
            <Stack direction="row" alignItems="center" spacing={2} >
               <Button variant="text" component="label">
                  Upload photo of Front of Property
               </Button>
               <IconButton color="primary" aria-label="upload picture" component="label">
                  <input
                     type="file"

                     accept="image/*"
                     capture="true"
                     multiple
                     hidden

                     name="myImage"
                     onChange={(event) => {
                        setPhotoOfFrontOfProperty([...photoOfFrontOfProperty, ...event.target.files]);
                     }}
                  />
                  <PhotoCamera />
               </IconButton>
            </Stack>
            <Box sx={{mx: 'auto', m: 1, p: 1, width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
               {photoOfFrontOfProperty.map((image, index) => (
                  <Stack direction="row" alignItems="center" spacing={1} >
                     <img
                        alt="Not found"
                        width="70px"
                        height="70px"
                        src={URL.createObjectURL(image)}
                     />
                     <Button sx={{width: "40px", maxHeight: "40px", pt: 1, m:0 }}
                             onClick={() => {
                                let temp = [...photoOfFrontOfProperty]
                                temp.splice(index, 1);
                                setPhotoOfFrontOfProperty(temp)
                             }}>
                        <RemoveCircleOutlineIcon  />
                     </Button>
                  </Stack>
               ))}
            </Box>
*/}

            {/*<UploadAndDisplayImage />*/}







            <Stack direction="row" alignItems="center" spacing={1} >
               <Typography>Upload photo of Front of Property</Typography>
               <IconButton color="primary" aria-label="upload picture" component="label" onClick={ () => {
                  dispatch({ type: 'SET_SHOW_CAMERA', payload: {property: 'photoOfFrontOfProperty', page: 'general'} })
               }}>
                  <PhotoCamera />
               </IconButton>
               <IconButton color="primary" aria-label="upload picture" component="label">
                  <input
                     type="file"

                     accept="image/*"
                     //capture="true"
                     //multiple
                     hidden

                     name="myImage"
                     onChange={(event) => {

                        console.log('event.target.files:')
                        console.log(event.target.files)

                        reduce.toBlob(event.target.files[0], { max: 900 })
                           .then(blob => {

                              const wrapSaveImage = async (dataUri) => {

                                 setPhotoOfFrontOfProperty(spinner)
                                 const wrapper = async () => {

                                    const base64 = await toBase64(dataUri);
                                    const params = {id: inspectionAllData.photoFolderId, data: { NAME: "inspectionPhoto.jpg"}, fileContent: base64.replace('data:image/jpeg;base64,', '').replace('data:image/png;base64,', ''), generateUniqueName: true}

                                    const savedPhotoData = await savePhotoIntoFolder(access_token_data, params)
                                    dispatch({ type: 'UPDATE_INSPECTION_ALL_DATA_WITH_PHOTO', payload: {...inspectionAllData, photoOfFrontOfProperty: savedPhotoData} })
                                    //dispatch({ type: 'SET_UPDATE_PHOTO_FOR_GENERAL' })
                                 }
                                 wrapper()
                              }
                              wrapSaveImage(blob)

                           });




                     }}
                  />
                  <GalleryIcon />
               </IconButton>
            </Stack>
{/*
            <Stack direction="row" alignItems="center" spacing={2}>
               <CustomCamera />
            </Stack>
*/}









            <Stack direction="row" alignItems="center" spacing={2}>

               {/*https://www.npmjs.com/package/mui-image*/}
               {/*<Image src={test_image} showLoading width={500} style={{ borderRadius: 16 }} />*/}

               {/*<Image src={photoOfFrontOfProperty} showLoading width={500} style={{ borderRadius: 16 }} />*/}


               <Image src={photoOfFrontOfProperty} showLoading width={600} style={{ borderRadius: 16 }} />

{/*               <Magnifier*/}
{/*                  imageSrc={photoOfFrontOfProperty}*/}
{/*//                  imageSrc={test_image}*/}
{/*                  imageAlt="Front Property Photo"*/}
{/*                  //largeImageSrc={test_image}*/}
{/*                  largeImageSrc={photoOfFrontOfProperty}*/}
{/*                  mouseActivation={MOUSE_ACTIVATION.DOUBLE_CLICK} // Optional*/}
{/*                  touchActivation={TOUCH_ACTIVATION.DOUBLE_TAP} // Optional*/}

{/*               />*/}

{/*
               <GlassMagnifier
                  imageSrc={test_image}
                  imageAlt="Example"
                  //largeImageSrc="./large-image.jpg" // Optional
               />
*/}
            </Stack>
            {/*<Typography variant="caption" sx={{color: "gray"}} >Tap twice to enlarge</Typography>*/}


            <Box sx={{
               display: 'flex',
               gap: 1,
            }}>


               <Box sx={{
                  display: 'flex',
                  backgroundColor: '#ffffff',
                  borderRadius: 1,
                  boxShadow: 2,
                  mt: 2,
                  p: 1,
                  gap: 1,
                  //                        mb: 2,
                  width: '70%'
               }}>

                  <Box sx={{display: 'flex', flexDirection: 'column', mt: 2, p: 1, gap: 2, mb: 2, width: "100%"}}>
                     <Box sx={{display: 'flex', gap: 1}}>
                        {/*<ContactPhoneIcon/>*/}
                        <TextField id="standard-basic" label="Name" variant="standard" fullWidth
                                   value={name}
                                   onChange={(event) => {
                                      setName(event.target.value)
                                   }}
                        />
                     </Box>
                     <Box sx={{display: 'flex', gap: 1}}>
                        {/*<ContactPhoneIcon/>*/}
                        <TextField id="standard-basic" label="Last Name" variant="standard" fullWidth
                                   value={lastName}
                                   onChange={(event) => {
                                      setLastName(event.target.value)
                                   }}
                        />
                     </Box>

                     <Box sx={{display: 'flex', gap: 1, alignItems: 'top', alignContent: 'top' }}>
                        {/*<AssistantDirectionIcon/>*/}
                        <TextField id="standard-basic" label="Address" variant="standard" fullWidth
                           multiline
                           rows={4}
                           value={address}
                           onChange={(event) => {
                             setAddress(event.target.value)
                           }}
                        />
                     </Box>
                     <Box sx={{display: 'flex', gap: 1}}>
                        {/*<ContactPhoneIcon/>*/}
                        <TextField id="standard-basic" label="Phone" variant="standard" fullWidth
                                   value={phone}
                                   onChange={(event) => {
                                      setPhone(event.target.value)
                                   }}
                        />
                     </Box>
                     <Box sx={{display: 'flex', gap: 1}}>
                        <TextField id="standard-basic" label="Email" variant="standard" fullWidth
                                   value={email}
                                   onChange={(event) => {
                                      setEmail(event.target.value)
                                   }}
                        />
                     </Box>

                  </Box>
               </Box>

               <Box sx={{
                  display: 'flex',
                  backgroundColor: '#ffffff',
                  borderRadius: 1,
                  boxShadow: 2,
                  mt: 2,
                  p: 1,
                  gap: 1,
                  //                        mb: 2,
                  width: '30%'
               }}>

                  <FormControl sx={{ m: 1 }} component="fieldset" variant="standard">
                     <FormGroup>
                        <FormControlLabel
                           control={
                              <Checkbox name="roof"
                                        checked={scopeOfWork.roof}
                                        onChange={(event) => {
                                           setScopeOfWork({...scopeOfWork, roof: event.target.checked })
                                        }}
                              />
                           }
                           label="Roof"
                        />
                        <FormControlLabel
                           control={
                              <Checkbox checked={scopeOfWork.siding} onChange={handleChange} name="siding"
                                        onChange={(event) => {
                                           setScopeOfWork({...scopeOfWork, siding: event.target.checked })
                                        }}
                              />
                           }
                           label="Siding"
                        />
                        <FormControlLabel
                           control={
                              <Checkbox checked={scopeOfWork.gutters} onChange={handleChange} name="gutters"
                                        onChange={(event) => {
                                           setScopeOfWork({...scopeOfWork, gutters: event.target.checked })
                                        }}
                              />
                           }
                           label="Gutters"
                        />
                        <FormControlLabel
                           control={
                              <Checkbox checked={scopeOfWork.windows} onChange={handleChange} name="windows"
                                        onChange={(event) => {
                                           setScopeOfWork({...scopeOfWork, windows: event.target.checked })
                                        }}
                              />
                           }
                           label="Windows"
                        />
                        <FormControlLabel
                           control={
                              <Checkbox checked={scopeOfWork.metals} onChange={handleChange} name="metals"
                                        onChange={(event) => {
                                           setScopeOfWork({...scopeOfWork, metals: event.target.checked })
                                        }}
                              />
                           }
                           label="Metals"
                        />
                        <FormControlLabel
                           control={
                              <Checkbox checked={scopeOfWork.interior} onChange={handleChange} name="interior"
                                        onChange={(event) => {
                                           setScopeOfWork({...scopeOfWork, interior: event.target.checked })
                                        }}
                              />
                           }
                           label="Interior"
                        />

                     </FormGroup>
                  </FormControl>
               </Box>
            </Box>

            <Box sx={{display: 'flex', mt: 2, p: 1, gap: 1, mx: 'auto'}}>
               <Autocomplete
                  disablePortal
                  id="linked-deal-combo-box"
                  options={dealList}
                  sx={{ width: '100%' }}
                  renderInput={(params) => <TextField {...params} label="Linked Deal" />}

                  value={linkedDealId}
                  onChange={(event, newValue) => {
                     setLinkedDealId(newValue);
                  }}
                  // inputValue={inputInsurerCarrier}
                  // onInputChange={(event, newInputValue) => {
                  //    setInputInsurerCarrier(newInputValue);
                  // }}
               />
            </Box>

            <Box sx={{display: 'flex', mt: 1, p: 1, gap: 1, mx: 'auto'}}>
               <LoadingButton
                  size="small"
                  //disabled={generateReportDisabled}
                  onClick={moveDealToClaimFiled}
                  loading={movingToClaimFiledStage}
                  loadingIndicator="processing…"
                  variant="outlined"
               >
                  <span>Move Deal to 'Claim Filed' Stage</span>
               </LoadingButton>
            </Box>


            <Box sx={{display: 'flex', mt: 2, p: 1, gap: 1, mx: 'auto'}}>
               <Autocomplete
                  disablePortal
                  id="second-responsible-person-combo-box"
                  options={userList}
                  sx={{ width: '100%' }}
                  renderInput={(params) => <TextField {...params} label="Second Responsible Person" />}

                  value={secondResponsiblePersonId}
                  onChange={(event, newValue) => {
                     setSecondResponsiblePersonId(newValue);
                  }}
               />
            </Box>

{/*
            <Box sx={{display: 'flex', mt: 1, p: 1, gap: 1, mx: 'auto'}}>
               <Typography variant="body2">Inspector Name: </Typography>
               <Typography variant="body2">{inspectorName}</Typography>
            </Box>
*/}

            <Box sx={{display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto'}}>
               <FormControl>
                  <FormLabel id="demo-row-radio-buttons-group-label">Is the Property Owner Present:</FormLabel>
                  <RadioGroup
                     row
                     aria-labelledby="demo-row-radio-buttons-group-label"
                     name="row-radio-buttons-group"
                     value={isThePropertyOwnerPresent}
                     onChange={(event) => {
                        setIsThePropertyOwnerPresent(event.target.value)
                     }}
                  >
                     <FormControlLabel value="female" control={<Radio />} label="Female" />
                     <FormControlLabel value="male" control={<Radio />} label="Male" />
                  </RadioGroup>
               </FormControl>
            </Box>

            <Box sx={{ minWidth: 120, display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto' }}>
               <FormControl fullWidth>
                  <InputLabel id="weather-condition-select-label">Weather Condition</InputLabel>
                  <Select
                     labelId="weather-condition-select-label"
                     id="weather-condition-select"
                     value={weatherCondition}
                     label="Weather Condition"
                     onChange={(event) => {
                        setWeatherCondition(event.target.value)
                     }}
                  >
                     <MenuItem value={197}>Sunny</MenuItem>
                     <MenuItem value={199}>Overcast</MenuItem>
                     <MenuItem value={201}>Wet</MenuItem>
                     <MenuItem value={203}>Other</MenuItem>
                  </Select>
               </FormControl>
            </Box>

            <Box sx={{display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto'}}>
               <TextField fullWidth id="approximate-age-of-structure" label="Approximate Age of Structure" variant="outlined"
                  value={approximateAgeOfStructure}
                  onChange={(event) => {
                    setApproximateAgeOfStructure(event.target.value)
                  }}
               />
            </Box>

            <Box sx={{display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto'}}>
               <TextField fullWidth id="approximate-age-of-siding" label="Approximate Age of Siding" variant="outlined"
                  value={approximateAgeOfSiding}
                  onChange={(event) => {
                    setApproximateAgeOfSiding(event.target.value)
                  }}
               />
            </Box>

            <Box sx={{display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto'}}>
               <TextField fullWidth id="approximate-age-of-gutters" label="Approximate Age of Gutters" variant="outlined"
                  value={approximateAgeOfGutters}
                  onChange={(event) => {
                    setApproximateAgeOfGutters(event.target.value)
                  }}
               />
            </Box>

            <Box sx={{display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto'}}>
               <TextField fullWidth id="approximate-age-of-roof" label="Approximate Age of Roof" variant="outlined"
                  value={approximateAgeOfRoof}
                  onChange={(event) => {
                    setApproximateAgeOfRoof(event.target.value)
                  }}
               />
            </Box>

            <Box sx={{display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto'}}>
               <TextField fullWidth id="additional-information" label="Additional Information" multiline rows={4}
                  value={additionalInformation}
                  onChange={(event) => {
                    setAdditionalInformation(event.target.value)
                  }}
               />
            </Box>

         </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded2 === 'panel_insurance'} onChange={handleChange2('panel_insurance')}>
         <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="insurance-content"
            id="insurance-header"
         >
            <Typography>Insurance Information</Typography>
         </AccordionSummary>
         <AccordionDetails>

            <Box sx={{display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto'}}>
               <Autocomplete
                  disablePortal
                  id="insurer-combo-box"
                  options={insuranceCarriers}
                  sx={{ width: '100%' }}
                  renderInput={(params) => <TextField {...params} label="Insurer Carrier" />}

                  value={insurerCarrier}
                  onChange={(event, newValue) => {
                     setInsurerCarrier(newValue);
                  }}
                  inputValue={inputInsurerCarrier}
                  onInputChange={(event, newInputValue) => {
                     setInputInsurerCarrier(newInputValue);
                  }}
               />
            </Box>

{/*
            <Box sx={{display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto'}}>
               <TextField fullWidth id="policy-number" label="Policy Number"
                  value={policyNumber}
                  onChange={(event) => {
                    setPolicyNumber(event.target.value)
                  }}
               />
            </Box>
*/}

            <Box sx={{display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto'}}>
               <TextField fullWidth id="claim-number" label="Claim Number"
                  value={claimNumber}
                  onChange={(event) => {
                    setClaimNumber(event.target.value)
                  }}
               />
            </Box>

            <Box sx={{ display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto' }}>
               <FormControl sx={{ m: 1 }} component="fieldset" variant="standard">
                  <FormLabel component="legend">Damage Caused By</FormLabel>
                  <FormGroup>
                     <FormControlLabel
                        control={
                           <Checkbox checked={false} onChange={handleChange} name="hail"
                              checked={damageCausedBy.hail}
                              onChange={(event) => {
                               setDamageCausedBy({...damageCausedBy, hail: event.target.checked })
                              }}
                           />
                        }
                        label="Hail"
                     />
                     <FormControlLabel
                        control={
                           <Checkbox checked={false} onChange={handleChange} name="hurricane"
                              checked={damageCausedBy.hurricane}
                              onChange={(event) => {
                               setDamageCausedBy({...damageCausedBy, hurricane: event.target.checked })
                              }}
                           />
                        }
                        label="Hurricane"
                     />
                     <FormControlLabel
                        control={
                           <Checkbox checked={false} onChange={handleChange} name="fire"
                                     checked={damageCausedBy.fire}
                                     onChange={(event) => {
                                        setDamageCausedBy({...damageCausedBy, fire: event.target.checked })
                                     }}
                           />
                        }
                        label="Fire"
                     />
                  </FormGroup>
               </FormControl>
               <FormControl
                  required
                  error={false}
                  component="fieldset"
                  sx={{ m: 3 }}
                  variant="standard"
               >
                  <FormGroup>
                     <FormControlLabel
                        control={
                           <Checkbox checked={false} onChange={handleChange} name="wind"
                                     checked={damageCausedBy.wind}
                                     onChange={(event) => {
                                        setDamageCausedBy({...damageCausedBy, wind: event.target.checked })
                                     }}
                           />
                        }
                        label="Wind"
                     />
                     <FormControlLabel
                        control={
                           <Checkbox checked={false} onChange={handleChange} name="tornado"
                                     checked={damageCausedBy.tornado}
                                     onChange={(event) => {
                                        setDamageCausedBy({...damageCausedBy, tornado: event.target.checked })
                                     }}
                           />
                        }
                        label="Tornado"
                     />
                     <FormControlLabel
                        control={
                           <Checkbox checked={false} onChange={handleChange} name="flooding"
                                     checked={damageCausedBy.flooding}
                                     onChange={(event) => {
                                        setDamageCausedBy({...damageCausedBy, flooding: event.target.checked })
                                     }}
                           />
                        }
                        label="Flooding"
                     />
                  </FormGroup>
               </FormControl>
            </Box>


            <Box sx={{ display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto' }}>
               <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                     label="Date of Loss"
                     value={dateOfLoss}
                     onChange={(newValue) => {
                        setDateOfLoss(newValue);
                     }}
                     renderInput={(params) => <TextField {...params} />}
                  />
               </LocalizationProvider>
            </Box>

            <Box sx={{ minWidth: 120, display: 'flex', mt: 0, p: 1, gap: 1, mx: 'auto' }}>
               <FormControl fullWidth>
                  <InputLabel id="inspection-result-select-label">Inspection Result</InputLabel>
                  <Select
                     labelId="inspection-result-select-label"
                     id="inspection-result-select"
                     label="Inspection Result"

                     value={inspectionResult}
                     onChange={(event) => {
                        setInspectionResult(event.target.value)
                     }}

                  >
                     <MenuItem value={217}>Damage Found – File Claim</MenuItem>
                     <MenuItem value={219}>Damage Found – Homeowner Already Filed</MenuItem>
                     <MenuItem value={221}>Damage Found – Homeowner Does Not Want to File</MenuItem>
                     <MenuItem value={223}>No Damage Found – No Claim Filed</MenuItem>
                  </Select>
               </FormControl>
            </Box>


         </AccordionDetails>
      </Accordion>



   </Box>
   </>

   );
}